<template>
  <div>
    <b-row>
      <b-col cols="12" md="12" sm="12">
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark"
                >گزارش تحلیلی فعالیت</span
              >
              <span class="text-muted mt-3 font-weight-bold font-size-sm">
                {{ report.ActiveGatewayCount + loadedActiveDollarGatewayCount }}
                درگاه فعال</span
              >
              <span class="text-muted mt-3 font-weight-bold font-size-sm">
                {{ loadedCustomerCount }} تعداد مشتریان ثبت نامی</span
              >
            </h3>
            <div class="card-toolbar">
              <b-button-group
                class="btn font-weight-bolder font-size-sm mr-3"
                squared
                label="از تاریخ"
              >
                <!-- <date-picker
          clearable
            range
           
            v-model="From"
            placeholder="از تاریخ تا تاریخ"
          /> -->
                <input
                  v-model="From"
                  type="text"
                  id="my-custom-input"
                  class="form-control rounded-0"
                  placeholder="از تاریخ تا تاریخ"
                />

                <date-picker
                  clearable
                  range
                  v-model="From"
                  element="my-custom-input"
                  :max="maxDate"
                />
                <b-button variant="success" @click="fromToDate(TypeShowChart)"
                  >جستجو</b-button
                >
              </b-button-group>

              <b-button-toolbar
                class="btn font-weight-bolder font-size-sm"
                key-nav
                aria-label="Toolbar with button groups"
              >
                <b-button-group style="background-color: #fff" class="mx-1">
                  <b-button squared @click="monthly" variant="outline-success"
                    >ماه</b-button
                  >
                  <b-button squared @click="weekly" variant="outline-success"
                    >هفته</b-button
                  >
                  <b-button squared @click="daily" variant="outline-success"
                    >روز</b-button
                  >
                </b-button-group>
              </b-button-toolbar>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="count"
              :chartdatas="ChartDataRial"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              seriesName="مجموع پرداختی"
              :columns="[
                {
                  name: 'تعداد تراکنش',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'تعداد تراکنش ها ریالی'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="count"
              :chartdatas="ChartDataDollar"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              seriesName="مجموع پرداختی"
              :columns="[
                {
                  name: 'تعداد تراکنش',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'تعداد تراکنش ها دلاری'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="sum"
              :chartdatas="ChartDataTransactionRial"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'مجموع پرداختی',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'مبلغ کل تراکنش های ریالی'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="sum"
              :chartdatas="ChartDataTransactionDollar"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'مجموع پرداختی',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'مبلغ کل تراکنش های دلاری'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!enable" class="row row-eq-height">
      <b-col class="" cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="count"
              :chartdatas="ChartDataGatewayRial"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'تعداد درگاه',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'تعداد درگاه های ریالی'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
      <b-col class="" cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="count"
              :chartdatas="ChartDataGatewayDollar"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'تعداد درگاه',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'تعداد درگاه های دلاری'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>

      <b-col class="" cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="sum"
              :chartdatas="ChartDataFondRial"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'مجموع پرداختی',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'درآمدها ریالی'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
      <b-col class="" cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="sum"
              :chartdatas="ChartDataFondDollar"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'مجموع پرداختی',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'درآمدها دلاری'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
      <b-col class="" cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="count"
              :chartdatas="ChartDataShare"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'مجموع پرداختی',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'تسویه ها'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" sm="6">
        <div class="card card-custom gutter-b">
          <!-- <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                Basic Card
                <small>sub title</small>
              </h3>
            </div>
          </div> -->
          <div class="card-body">
            <shepaChart
              type_opration="count"
              :chartdatas="ChartDataRegister"
              :charttype="'line'"
              :group_col="TypeShowChart"
              :XYTitle="XYTitle"
              :columns="[
                {
                  name: 'تعداد کل ثبت نامی',
                  field_name: 'cost',
                  field_type: 'count',
                },
              ]"
              :title="'تعداد کل ثبت نامی ها'"
              :biId="-2"
            ></shepaChart>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="row row-eq-height"> </b-row>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_CUSTOMER_COUNT } from "@/core/services/store/getCountCustomer.module";
import ShepaChart from "@/components/Chart";
import httpHelper from "../../helpers/httpHelper";
import * as moment from "jalali-moment";

export default {
  name: "Reports",
  props: ["enable"],
  data() {
    return {
      report: {
        todayTransCount: 0,
        todayTransSum: 0,
        ActiveGatewayCount: 0,
        clientsCount: 0,
        MonthIncome: 0,
        todayincome: 0,
        sattling: 0,
      },
      From: [],
      ChartDataRial: [],
      ChartData2: [],
      ChartDataFondRial: [],
      ChartDataFondDollar: [],
      ChartDataTransactionRial: [],
      ChartDataShare: [],
      ChartDataRefund: [],
      ChartDataDollar: [],
      ChartDataTransactionDollar: [],
      ChartDataRegister: [],
      ChartDataGatewayRial: [],
      ChartDataGatewayDollar: [],
      TypeShowChart: "daily",
      typeOpration: "sum",
      listTicket: [],
      XYTitle: { x_title: null, y_title: null },
      maxDate:null,
      minDate:null,
      currentMonth:null,
    };
  },
  components: { ShepaChart },
  computed: {
    loadedBalanceSaman1() {
      return this.$store.getters.loadedBalanceSaman1;
    },
    loadedBalanceSaman2() {
      return this.$store.getters.loadedBalanceSaman2;
    },
    loadedBalanceSaderat() {
      return this.$store.getters.loadedBalanceSaderat;
    },
    loadedCustomerCount() {
      return this.$store.getters.loadedCustomerCount;
    },
    loadedActiveDollarGatewayCount() {
      return this.$store.getters.loadedActiveDollarGatewayCount;
    },
  },
  mounted() {
    const date = moment(new Date()).format("jYYYY/jMM/jDD");
    this.maxDate=date;
    this.currentMonth=parseInt(moment(new Date()).format("jMM"));
    this.minDate=moment(moment(moment(new Date()).subtract(1, 'months')._d)).add(2,'days').format("jYYYY/jMM/jDD");
    this.From=[this.minDate,this.maxDate];

    this.getTickets();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گزارشات تحلیلی" }]);
    httpHelper.getData("admindashboard").then((res) => {
      this.report = res.result;
    });

    this.daily();
    this.getCountCustomer();
  },
  methods: {
    fromToDate(e) {
      this.getChartLineCount("483");
      this.getChartLineCount("1722");
      this.getChartLineSum("483");
      this.getChartLineSum("1722");
      this.getChartLineIncome("483");
      this.getChartLineIncome("1722");
      this.getChartLineRegisters();
      this.getChartLineShares();
      this.getChartLineRefund();
      this.getChartLineGateway("483");
      this.getChartLineGateway("1722");
    },
    monthly() {
      this.TypeShowChart = "monthly";
      this.getChartLineCount("483");
      this.getChartLineCount("1722");
      this.getChartLineSum("483");
      this.getChartLineSum("1722");
      this.getChartLineIncome("483");
      this.getChartLineIncome("1722");
      this.getChartLineRegisters();
      this.getChartLineShares();
      this.getChartLineRefund();
      this.getChartLineGateway("483");
      this.getChartLineGateway("1722");
    },
    weekly() {
      this.TypeShowChart = "weekly";
      this.getChartLineCount("483");
      this.getChartLineCount("1722");
      this.getChartLineSum("483");
      this.getChartLineSum("1722");
      this.getChartLineIncome("483");
      this.getChartLineIncome("1722");
      this.getChartLineRegisters();
      this.getChartLineShares();
      this.getChartLineRefund();
      this.getChartLineGateway("483");
      this.getChartLineGateway("1722");
    },
    daily() {
      this.TypeShowChart = "daily";
      this.getChartLineCount("483");
      this.getChartLineCount("1722");
      this.getChartLineSum("483");
      this.getChartLineSum("1722");
      this.getChartLineIncome("483");
      this.getChartLineIncome("1722");
      this.getChartLineRegisters();
      this.getChartLineShares();
      this.getChartLineRefund();
      this.getChartLineGateway("483");
      this.getChartLineGateway("1722");
    },
    getChartLineCount(moneyType) {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      let money_type = moneyType;
      this.ChartDataRial=[];
      this.ChartDataDollar=[];
      httpHelper
        .getData(
          `transactions/chart?dateFrom=${from}&dateTo=${to}&type=${typeShow}&sumOrCount=count&rialOrDollar=${money_type}`
        )
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "count"
            );
            this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
           this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            money_type == "483"
              ? (this.ChartDataRial = value)
              : (this.ChartDataDollar = value);
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
        });
    },
    getChartLineSum(moneyType) {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      let money_type = moneyType;
      this.ChartDataTransactionRial = [];
      this.ChartDataTransactionDollar = [];
      httpHelper
        .getData(
          `transactions/chart?dateFrom=${from}&dateTo=${to}&type=${typeShow}&sumOrCount=sum&rialOrDollar=${money_type}`
        )
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "sum"
            );
             this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
             this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            money_type == "483"
              ? (this.ChartDataTransactionRial = value)
              : (this.ChartDataTransactionDollar = value);
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
          // this.ChartDatas = res.result;
        });
    },
    getChartLineIncome(moneyType) {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      let money_type = moneyType;
      this.ChartDataFondRial = [];
      this.ChartDataFondDollar = [];
      httpHelper
        .getData(
          `charts/fond?dateFrom=${from}&dateTo=${to}&type=${typeShow}&sumOrCount=sum&rialOrDollar=${money_type}`
        )
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "sum"
            );
             this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
             this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            this.ChartDataFond = value;
            money_type == "483"
              ? (this.ChartDataFondRial = value)
              : (this.ChartDataFondDollar = value);
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
          // this.ChartDatas = res.result;
        });
    },
    getChartLineRegisters() {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      this.ChartDataRegister=[];
      httpHelper
        .getData(
          `charts/registers?dateFrom=${from}&dateTo=${to}&type=${typeShow}&sumOrCount=count`
        )
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "count"
            );
             this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
             this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            this.ChartDataRegister = value;
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
          // this.ChartDatas = res.result;
        });
    },
    getChartLineShares() {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      this.ChartDataShare=[];

      httpHelper
        .getData(`share/chart?dateFrom=${from}&dateTo=${to}&type=${typeShow}`)
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "count"
            );
             this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
             this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            this.ChartDataShare = value;
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
          // this.ChartDatas = res.result;
        });
    },
    getChartLineRefund() {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      this.ChartDataRefund=[];

      httpHelper
        .getData(`refund/chart?dateFrom=${from}&dateTo=${to}&type=${typeShow}`)
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "count"
            );
             this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
             this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            this.ChartDataRefund = value;
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
          // this.ChartDatas = res.result;
        });
    },
    getChartLineGateway(moneyType) {
      let from = this.From.length != 0 ? this.From[0] : "";
      let to = this.From.length != 0 ? this.From[1] : "";
      let typeShow = this.TypeShowChart;
      let money_type = moneyType;
      this.ChartDataGatewayRial=[];
      this.ChartDataGatewayDollar=[];

      httpHelper
        .getData(
          `payment-gateway/chart?dateFrom=${from}&dateTo=${to}&type=${typeShow}&rialOrDollar=${money_type}`
        )
        .then((res) => {
          let result = [];
          if (res.success) {
            typeShow !== "daily"
              ? res.result.forEach((element) => {
                  element.date = element.date - 1;
                })
              : null;
            let value = this.ReportCalculate(
              res.result,
              this.TypeShowChart,
              "count"
            );
             this.currentMonth > 6 && this.From.length==0 && this.TypeShowChart == "daily" ? value.pop() : null;
             this.From.length!=0 && (parseInt(moment(from).format("jMM")) || parseInt(moment(to).format("jMM"))) > 6 && this.TypeShowChart == "daily" ? value.pop() : null;
            money_type == "483"
              ? (this.ChartDataGatewayRial = value)
              : (this.ChartDataGatewayDollar = value);
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "اطلاعاتی برای درخواست شما وجود ندارد.",
              5000
            );
          }
        });
    },
    getTickets() {
      httpHelper.getData("charts/get_top_ticket").then((res) => {
        this.listTicket = res;
      });
    },
    getCountCustomer() {
      this.$store.dispatch(GET_CUSTOMER_COUNT, "admindashboard");
    },
    ReportCalculate(result, typeShowChart, sumOrCount = null) {
      let monthly = [];
      switch (typeShowChart) {
        case "monthly":
          if (sumOrCount == "count") {
            Object.assign(this.XYTitle, { x_title: "ماه", y_title: "تعداد" });
          } else {
            Object.assign(this.XYTitle, { x_title: "ماه", y_title: "مبلغ" });
          }

          for (let index = 0; index <= 11; index++) {
            if (sumOrCount == "count") {
              monthly.push({ date: index, count: 0 });
            } else {
              monthly.push({ date: index, rialCost: 0 });
            }
          }

          for (var i = 0, l = monthly.length; i < l; i++) {
            for (var j = 0, ll = result.length; j < ll; j++) {
              if (monthly[i].date === result[j].date) {
                monthly.splice(i, 1, result[j]);
                break;
              }
            }
          }
          return monthly;
        case "weekly":
          if (sumOrCount == "count") {
            Object.assign(this.XYTitle, { x_title: "هفته", y_title: "تعداد" });
          } else {
            Object.assign(this.XYTitle, { x_title: "هفته", y_title: "مبلغ" });
          }
          for (let index = 0; index < 7; index++) {
            if (sumOrCount == "count") {
              monthly.push({ date: index, count: 0 });
            } else {
              monthly.push({ date: index, rialCost: 0 });
            }
          }

          for (var i = 0, l = monthly.length; i < l; i++) {
            for (var j = 0, ll = result.length; j < ll; j++) {
              if (monthly[i].date === result[j].date) {
                monthly.splice(i, 1, result[j]);
                break;
              }
            }
          }
          return monthly;
        case "daily":
          if (sumOrCount == "count") {
            Object.assign(this.XYTitle, { x_title: "روز", y_title: "تعداد" });
          } else {
            Object.assign(this.XYTitle, { x_title: "روز", y_title: "مبلغ" });
          }
          monthly = result;
          return monthly;

        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.badge-light-success {
  color: #1bc5bd !important;
  background-color: #c9f7f5;
}
.badge-light-blue {
  color: #3699ff !important;
  background-color: #e1f0ff;
}
.badge-light-orange {
  color: #ffa800 !important;
  background-color: #fff4de;
}
.badge-light-purple {
  color: #8950fc !important;
  background-color: #eee5ff;
}
.badge-light-red {
  color: #f64e60 !important;
  background-color: #ffe2e5;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
